var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-dialog-content',{attrs:{"loading":true}},[_c('div',{staticClass:"absolute top-2 left-2 right-2 bottom-2"},[_c('iframe',{attrs:{"src":_vm.path,"title":`Invoice for Order ${_vm.orderId}`,"height":"100%","width":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }